import React, { useMemo, useState } from 'react';
import { DragNDropContext } from './useDragNDropContext';

export function DragNDropProvider({ children }: { children: React.ReactNode }) {
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [isDropping, setIsDropping] = useState<boolean>(false);

  const state = useMemo(() => ({
    isDragging,
    isDropping,
    setIsDragging,
    setIsDropping,
  }), [isDragging, isDropping, setIsDragging, setIsDropping]);

  return (
    <DragNDropContext.Provider
      value={state}
    >
      {children}
    </DragNDropContext.Provider>
  );
}
